




import Vue from 'vue'
import UserForm from '@/views/User/views/UserForm.vue'

export default Vue.extend({ name: 'CreateUser', components: { UserForm } })
